import Account from '@/features/Account';
import Basket from '@/features/Basket';
import ForgotPassword from '@/features/ForgotPassword';
import Main from '@/features/Main';
import SignIn from '@/features/SignIn';
import SignUp from '@/features/SignUp';
import AirTransportBookingSuccess from '@/features/TransportList/components/Booking/components/BookingSuccess';
import Welcome from '@/features/Welcome';
import ProtectedRoute from '@infrastructure/router/ProtectedRoute';
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { Paths } from './paths';
import { CustomRootErrorBoundary } from '@/components/ErrorBoundaryFallback';

const AccommodationList = lazy(() => import('@/features/AccommodationList'));
const AccommodationBookingSuccess = lazy(
  () =>
    import(
      '@/features/AccommodationList/components/Booking/components/BookingSuccess'
    )
);
const TransportList = lazy(() => import('@/features/TransportList'));

type ExtendedRoute = RouteObject & {
  nameKey?: string;
  children?: ExtendedRoute[];
};

const routes: ExtendedRoute[] = [
  {
    path: Paths.Main,
    Component: Main,
    nameKey: 'Main',
    errorElement: <CustomRootErrorBoundary />,
    children: [
      {
        path: Paths.AirTransport,
        Component: TransportList
      },
      {
        path: Paths.Accommodations,
        Component: AccommodationList
      },
      {
        path: Paths.AccommodationBookingSuccess,
        Component: AccommodationBookingSuccess
      },
      {
        path: Paths.AirTransportBookingSuccess,
        Component: AirTransportBookingSuccess
      },
      {
        index: true,
        Component: Welcome
      }
    ]
  },
  {
    path: Paths.SignUp,
    Component: SignUp
  },
  {
    path: Paths.SignIn,
    Component: SignIn
  },
  {
    path: Paths.ForgotPassword,
    Component: ForgotPassword
  },
  {
    path: Paths.Basket,
    Component: Basket
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: Paths.AccountMain,
        Component: Account
      }
    ]
  }
];

export default routes;
